/**
 * When one of these keys is used by the client, then the client is navigating with the keyboard.
 * The space, enter and escape keys are not included because they are used after the client issued
 * an arrow or a tab key.
 */
export const NAVIGATION_KEYS = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Tab'];
